import * as React from "react";
import * as moment from "moment";
import {Link, RouteComponentProps} from "react-router-dom";
import {
    AnnualPolicyInfo,
    AnnualPolicyPremiumTypeEnum,
    FalconNavigatorHeader,
    FEEDBACK_DIALOG_DISPLAY_COUNTER,
    FEEDBACK_DIALOG_DISPLAY_EVENT,
    ICacheManager,
    ICustomerPortalService,
    InstalmentsInfo,
    INTERACTION_PROCESS_CLAIM_IMPACT,
    INTERACTION_PROCESS_MTA_EDIT_CAR_DETAILS,
    INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE,
    INTERACTION_PROCESS_MTA_REPLACE_CAR,
    INTERACTION_PROCESS_MTC,
    INTERACTION_PROCESS_MTC_LV,
    INTERACTION_PROCESS_NB,
    INTERACTION_PROCESS_PENDING_RENEWAL,
    INTERACTION_PROCESS_PENDING_RENEWAL_DD,
    INTERACTION_PROCESS_RENEWAL,
    NEW_PAYMENT,
    Party,
    PaymentCard,
    Policy,
    POLICY_STATUS_MTC,
    POLICY_STATUS_PENDING_RENEWAL,
    POLICY_STATUS_UNDERWRITING_FAILURE,
    PolicyProperty,
    PolicyPropertyEnum,
    PREMIUM_TYPE_ANNUAL,
    PREMIUM_TYPE_MONTHLY,
    productHelper,
    ProductsEnum,
    Quote,
    Renewal,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED,
    Subscription,
    Types
} from "@falcon/services";
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {AnnualProductPaymentMessageBanner} from "../../../../../components/banners/AnnualProductPaymentMessageBanner";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {UnpaidChangeBanner} from "../../../../../components/banners/UnpaidChangeBanner";
import * as Driver from "driver.js";
import {finalize} from "rxjs/operators";
import {ChargebackBanner} from "../../../../../components/banners/ChargebackBanner";
import {CardExpiryBanner} from "../../../../../components/banners/CardExpiryBanner";
import {
    findMainAnnualPaymentCardByMainCardId,
    findPreviousPolicyVersionByAgreementVersion,
    formatDateDMY,
    formatDateTime,
    getAmountToDisplay,
    getAmountWithDecimalDigits
} from "../../../../../CommonFunctions";
import * as MobileDetect from "mobile-detect";
import {NextYearAutoRenewalBanner} from "../../../../../components/banners/NextYearAutoRenewalBanner";
import {PolicyWillBeRenewedBanner} from "../../../../../components/banners/PolicyWillBeRenewedBanner";
import {RenewalDeclinedBanner} from "../../../../../components/banners/RenewalDeclinedBanner";
import {AutoRenewalInviteBanner} from "../../../../../components/banners/AutoRenewalInviteBanner";
import {PolicyWillBeRenewedConfirmation} from "../../../../../components/modals/PolicyWillBeRenewedConfirmation";
import {AutoRenewalInviteAfterLogin} from "../../../../../components/modals/AutoRenewalInviteAfterLogin";
import {NoActivePolicyBanner} from "../../../../../components/banners/NoActivePolicyBanner";
import {GracePeriodBanner} from "../../../../../components/banners/GracePeriodBanner";
import {MtaLimitWarningBanner} from "../../../../../components/banners/MtaLimitWarningBanner";
import {CoronaBanner} from "../../../../../components/banners/CoronaBanner";
import {ILookupService, Types as JourneyCoreTypeDefs} from "@athena-portal/plugin-journey";
import {ClaimImpactMtaSuccessModalWordingGenerator} from "./ClaimImpactMtaSuccessModalWordingGenerator";
import {SuccessfulPurchaseModal} from "../../../../../components/modals/SuccessfulPurchaseModal";
import {StorageSuccessModal} from "../../../../../components/modals/StorageSuccessModal";
import {RenewNextYearConfirmationModal} from "../../../../../components/modals/RenewNextYearConfirmationModal";
import {AutoRenewalQuestionModal} from "../../../../../components/modals/AutoRenewalQuestionModal";
import {AnnualTiles} from "./AnnualTiles";
import {FutureMTAExplainedHeader} from "../yourCarsPage/FutureMTAExplainedHeader";
import {AutomaticRenewalSuccessModal} from "../../../../../components/modals/AutomaticRenewalSuccessModal";
import {SportsVoucherBanner} from "../../../../../components/banners/SportsVoucherBanner";
import {OverdueInstalmentBanner} from "../../../../../components/banners/OverdueInstalmentBanner";
import {LVDataLayerHelper} from "../../../../../utils/LVDataLayerHelper";
import {DashcamBanner} from "../../../../../components/banners/DashcamBanner";
import {OutstandingPaymentBanner} from "../../../../../components/banners/OutstandingPaymentBanner";
import {SportsPassBanner} from "../../../../../components/banners/SportsPassBanner";
import {NCDImpactedClaimBanner} from "../../../../../components/banners/NCDImpactedClaimBanner";
import {UpcomingReplaceCarCoverBanner} from "../../../../../components/banners/UpcomingReplaceCarCoverBanner";
import {DirectDebitProposalModal} from "../../../../../components/modals/DirectDebitProposalModal";
import {QuickQuoteBanner} from "../../../../../components/banners/QuickQuoteBanner";
import {pushToAdobeDataLayerDelayed} from "../../../../../utils/AdobeDataLayerHelper";
import {GracePeriodModal} from "../../../../../components/modals/GracePeriodModal";
import {AllianzAdvantagesBanner} from "../../../../../components/banners/AllianzAdvantagesBanner";

interface IPolicySummaryPageParams {
    policyNumber: string;
}

interface IPolicySummaryPageProps extends RouteComponentProps<IPolicySummaryPageParams> {
    location: any;
}

interface IState {
    policy?: Policy;
    hasExpiredPolicies?: boolean;
    hasOldPolicies?: boolean;
    subscription?: Subscription;
    party?: Party;
    partyLoaded: boolean;
    quotes?: Quote[];
    quotesLoaded: boolean;
    claimSubmissionDate?: string;
    oldMissedPaymentProcess?: boolean;
    instalmentsInfo?: InstalmentsInfo;
    allInstalmentsInfo?: InstalmentsInfo;
    combinedInstalmentsInfo?: InstalmentsInfo;
    instalmentInfoLoaded: boolean;
    onlyAnnualMotorPolicyPresent: boolean;
    showCardExpiryBanner: boolean;
    showFeedbackDialog: boolean;
    displayOverlay: boolean;
    renewalProposal?: Renewal;
    automaticRenewalOn: boolean;
    performRenewal: boolean;
    displayWillBeRenewedConfirmation: boolean;
    classifiersLoaded: boolean;
    policiesProcessed: boolean;
    policyPropertiesLoaded: boolean;
    mainCardId?: string;
    cardExpired?: boolean;
    showRenewalSwitchConfirmation: boolean;
    showAutoRenewalQuestionModal: boolean;
    showAutoRenewalQuestionSuccessModal: boolean;
    registrationNumber?: string;
    paymentType: string;
    reuseCard: boolean;
    hasOldHomePolicies?: boolean;
    previousMonthlyPremium?: number;
    showDirectDebitProposalModal: boolean;
}

@authorize
export class AnnualMotorDashboardPage extends React.Component<IPolicySummaryPageProps, IState> {

    private static readonly ENABLE_AUTO_RENEWAL: string = "enable_auto_renewal";

    private pluginTemplates = new PluginTemplates();
    private showSuccessPopup: string | null;
    private successPopupTitle: string;
    private modalContent: React.JSX.Element;
    private tourDriver: Driver;
    private referrerJourney: string | null;
    private mobileDetect: MobileDetect;
    private modalAnythingElseChangedTitle: string;
    private explanationAnythingElseWording: string;
    private readonly multiPolicyAccount: boolean;

    private urlParams = new URLSearchParams(window.location.search);

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    private lookupService: ILookupService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    private pushToAdobeDataLayerTimeout: any;

    constructor(props: IPolicySummaryPageProps) {
        super(props);

        this.state = {
            quotesLoaded: false,
            partyLoaded: false,
            instalmentsInfo: {} as InstalmentsInfo,
            allInstalmentsInfo: {} as InstalmentsInfo,
            combinedInstalmentsInfo: {} as InstalmentsInfo,
            instalmentInfoLoaded: false,
            onlyAnnualMotorPolicyPresent: false,
            showCardExpiryBanner: false,
            showFeedbackDialog: false,
            displayOverlay: false,
            renewalProposal: undefined,
            automaticRenewalOn: false,
            performRenewal: false,
            displayWillBeRenewedConfirmation: false,
            classifiersLoaded: false,
            policiesProcessed: false,
            policyPropertiesLoaded: false,
            showAutoRenewalQuestionModal: false,
            showAutoRenewalQuestionSuccessModal: false,
            showRenewalSwitchConfirmation: false,
            registrationNumber: '',
            paymentType:'',
            reuseCard: false,
            showDirectDebitProposalModal: false,
        };

        this.multiPolicyAccount = window.sessionStorage.getItem("multiPolicyAccount") === "true";

        this.tourDriver = new Driver({
            animate: false,
            // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
            // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
            // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
            onHighlightStarted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    document.body.style["pointer-events"] = "none";
                }
                // onHighlightStarted() is called - tour dialog is open
                this.tourDriver["isOpen"] = true;
            },
            // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
            // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
            // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
            onHighlighted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    setTimeout( () => {
                        document.body.style["pointer-events"] = "auto";
                    }, 500);

                }
            },

            onReset: () => {
                // this is workaround to detect that tour dialog is closed
                // there is no "on close" callback
                // onReset() is called also before dialog is open, hence we need flag tourDriver.isOpen
                if (this.tourDriver["isOpen"]) {
                    // tour dialog is closed - remove the flag
                    delete this.tourDriver["isOpen"];
                    this.setState({displayOverlay: true});
                    this.displayReviewDialog();
                    this.setState({displayOverlay: false});
                }
            },

        });

        this.setTour = this.setTour.bind(this);
        this.turnOnNextYearRenewal = this.turnOnNextYearRenewal.bind(this);
        this.setAutomaticRenewal = this.setAutomaticRenewal.bind(this);
        this.setPerformRenewal = this.setPerformRenewal.bind(this);

        this.mobileDetect = new MobileDetect(window.navigator.userAgent);
    }

    public async componentDidMount() {
        this.pluginTemplates.setPageTitle("Dashboard");
        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            const policyNumber = this.props.match.params.policyNumber;
            const wolfPolicies: Policy[] = policies
                .filter((policy1: Policy) => policy1.products.includes(ProductsEnum.WOLF_MOTOR) && policy1.policyNumber === policyNumber)
                .sort((a, b) => moment(b.endDate).diff(a.endDate));

            if (wolfPolicies.length === 0) {
                this.setState({
                    policiesProcessed: true
                });
                return;
            }

            this.customerPortalService.getPolicyHistory().subscribe(
                (allPolicies: Policy[]) => {
                    let policy = wolfPolicies.find(p => p.policyNumber === policyNumber);
                    const previousPolicyVersion = findPreviousPolicyVersionByAgreementVersion(allPolicies, this.props.match.params.policyNumber);
                    if (previousPolicyVersion) {
                        const previousInstalments = previousPolicyVersion.interaction.paymentDetails.instalmentPlan.instalments[0];
                        const previousMonthlyPremium = previousInstalments?.principal + previousInstalments?.interest;
                        this.setState({previousMonthlyPremium});
                    }

                    if (policy?.interaction.process === INTERACTION_PROCESS_MTA_REPLACE_CAR && moment().isBefore(policy.interaction.headerInfo.startDate)) {
                        policy = allPolicies.find(p => p.policyNumber === policy?.policyNumber && p.interaction.agreementVersion === policy.interaction.agreementVersion - 1);
                    }

                    this.setState({
                        registrationNumber: policy?.insuredVehicles[0].registrationNumber})
                }
            );

            this.mountForPolicy(wolfPolicies![0]);

            this.setState(prevState => ({
                onlyAnnualMotorPolicyPresent: (prevState.subscription?.allPoliciesAreCancelled && productHelper.includesOnlyWolfMotorProduct(policies))
                    || productHelper.includesOnlyNonExpireWolfMotorProduct(policies),
            }));

        });

        this.customerPortalService.getExpiredPolicies().subscribe(policies => {
            this.setState({
                hasExpiredPolicies: Boolean(policies && policies.length > 0),
                hasOldHomePolicies: this.hasOldHomePolicies(policies),
            });
        });

        // TODO: This implementation will be changed after FAL-13075
        this.customerPortalService.getQuotes().subscribe(
            (quotes: Quote[]) => {
                this.setState({
                    quotes,
                    quotesLoaded: true
                })
            }
        );

        this.lookupService.fetchLookupValues(`all${ProductsEnum.WOLF_MOTOR}`, "en-UK")
            .subscribe(() => {
                this.setState({classifiersLoaded: true})
            });

        this.pushToAdobeDataLayerTimeout = pushToAdobeDataLayerDelayed(2000);
    }

    componentWillUnmount() {
        clearTimeout(this.pushToAdobeDataLayerTimeout);
    }

    private mountForPolicy = (policy: Policy) => {
        policy.interaction?.agreementVersionId ?
            this.mountInstalmentInfo(policy.interaction) :
            this.setState({instalmentInfoLoaded: true})

        const agreementVersionIds: number[] = policy.policyHistoryList.map(ph => ph.id);
        this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
            .subscribe((combinedInstalmentsInfo: any) => {
                this.setState({combinedInstalmentsInfo});
            });

        this.setState({
            policy,
            policiesProcessed: true
        });

        this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
            this.setState({subscription});
        });
        this.customerPortalService.getProfile().subscribe((party: Party) => {
            this.setState({party, partyLoaded: true});
        });

        this.customerPortalService.getRenewalProposal(policy.policyNumber).subscribe(
            (renewalProposal: Renewal) => {
                this.setState({
                    renewalProposal
                });

                if (this.urlParams.get(AnnualMotorDashboardPage.ENABLE_AUTO_RENEWAL) === "true") {
                    const hasPendingRenewal: boolean = renewalProposal != null && renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;
                    if (hasPendingRenewal) {
                        this.setAutomaticRenewal(true);
                        this.setState({
                            displayWillBeRenewedConfirmation: true,
                        })
                    }
                }
            }
        );

        this.customerPortalService.getPolicyHistoryAfterRenewal().subscribe((policyHistories: Policy[]) => {
            this.setState({
                hasOldPolicies: Boolean(policyHistories && policyHistories.length > 0)
            });
        });

        this.customerPortalService.getPolicyPaymentTypeByPolicyNumber(this.props.match.params.policyNumber).subscribe((paymentType: any) => {
            this.setState({
                paymentType
            });
        });

        this.customerPortalService.getPolicyPropertiesByPropertyKeys(this.props.match.params.policyNumber,
            [PolicyPropertyEnum.AUTOMATIC_RENEWAL, PolicyPropertyEnum.PERFORM_RENEWAL, PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD, PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED, PolicyPropertyEnum.REUSE_MAIN_CARD])
            .pipe(finalize(() => this.setState({policyPropertiesLoaded: true})))
            .subscribe(
                (properties: PolicyProperty[]) => {
                    properties.forEach(property => {
                        if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                            this.setState({automaticRenewalOn: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                            this.setState({performRenewal: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD) {
                            this.setState({mainCardId: property.value});
                        } else if (property.key === PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED) {
                            this.setState({cardExpired: property.value === 'true'});
                        } else  if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                            this.setState({reuseCard: property.value === 'true'})
                        }
                    })
                }
            );
    }

    private mountInstalmentInfo = (interaction: any) => {
        const policyVersionId = interaction.agreementVersionId;
        const premiumType = interaction.factors?.premiumType;
        if (premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY) {
            this.customerPortalService.getInstalmentsInfo(policyVersionId).subscribe(
                this.setStateInstalmentInfo
            );
        } else if (premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL
            && interaction.renewalDetails?.policyAgeYears > 0) {
            this.customerPortalService.getInstalmentsInfoByAgreementNumber(this.props.match.params.policyNumber).subscribe(
                this.setStateAllInstalmentInfo
            );
            this.customerPortalService.getMissedPaymentInfo(policyVersionId).subscribe(
                this.setStateInstalmentInfo
            );
        } else {
            this.setState({instalmentInfoLoaded: true});
        }
    }

    private setStateAllInstalmentInfo = (allInstalmentsInfo: InstalmentsInfo) => {
        this.setState({
            allInstalmentsInfo,
        });
    }

    private setStateInstalmentInfo = (instalmentsInfo: InstalmentsInfo) => {
        this.setState({
            instalmentsInfo,
            instalmentInfoLoaded: true
        });
    }

    public render() {
        const {
            policy,
            hasExpiredPolicies,
            hasOldPolicies,
            subscription,
            party,
            quotesLoaded,
            instalmentInfoLoaded,
            policiesProcessed
        } = this.state;
        const dataLoaded = policiesProcessed && instalmentInfoLoaded && (!policy || party && subscription && quotesLoaded)
            && (hasExpiredPolicies != null || hasOldPolicies != null) && policiesProcessed;

        // Recreate DataLayer
        if (policy) {
            const interaction = policy.interaction;
            new LVDataLayerHelper().mapInteractionToDataLayer(interaction);
        }

        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
        const onClose = this.setPopups();

        return (
            <>
                <Overlay show={!dataLoaded || this.state.displayOverlay || !this.state.classifiersLoaded}/>
                {this.showSuccessPopup && dataLoaded && (
                    this.renderSuccessModal(onClose)
                )}
                {this.state.showRenewalSwitchConfirmation && <RenewNextYearConfirmationModal/>}
                <FalconHeader/>
                <div className="page-contents dashboard-page pt-3">
                    <FalconNavigatorHeader
                        back={{
                            link: "/dashboard",
                            hidden: !this.multiPolicyAccount
                        }}
                        title={this.multiPolicyAccount ? 'Car policy' : `Hi ${policy?.policyHolder.firstName ?? ""}`}>
                        {policy && <div
                            className="number-plate-preview mx-0 mb-4">{this.state.registrationNumber}</div>}
                    </FalconNavigatorHeader>
                    {dataLoaded && policy && (
                        <>
                            {this.renderBanners()}
                            <AnnualTiles
                                policies={[policy]}
                                subscription={this.state.subscription}
                                renewalProposal={this.state.renewalProposal}
                                policyNumber={this.props.match.params.policyNumber}
                                hasExpiredPolicies={this.state.hasExpiredPolicies}
                                hasOldPolicies={this.state.hasOldPolicies}
                                hasMultiplePolicies={false}
                                renewalEnabled={this.state.performRenewal}
                                hasOldHomePolicies={this.state.hasOldHomePolicies}
                                {...this.props}
                            />
                            {this.state.onlyAnnualMotorPolicyPresent && this.state.policy!.interaction.policyHolder.ownsHome
                                && <QuickQuoteBanner
                                    policyHolder={this.state.policy!.policyHolder}
                                    policy={policy}
                                    {...this.props}/>}
                        </>
                    )}
                    {this.multiPolicyAccount && <BackButton isTop={false} link={"/dashboard/"}/>}
                </div>
                <FalconFooter/>
            </>
        )
    }

    private renderBanners(): React.JSX.Element {
        const {
            instalmentsInfo,
            party,
            renewalProposal
        } = this.state;

        const directDebitProposal: boolean = process.env.REACT_APP_MONTHLY_CARD_TO_MONTHLY_DIRECT_DEBIT_ENABLED ? JSON.parse(process.env.REACT_APP_MONTHLY_CARD_TO_MONTHLY_DIRECT_DEBIT_ENABLED) : false;

        const policy: Policy = this.state.policy!;
        if (!policy) {
            return <></>;
        }

        const interaction = policy.interaction;
        const showCardExpiryBanner: boolean = this.state.cardExpired !== undefined;
        const vehicle: any = interaction.vehicles[0];
        const isDirectDebitPaymentType: boolean = this.state.paymentType === "directDebit";
        const isDirectDebitDetailsSet: boolean = renewalProposal?.paymentDetails.directDebitDetails !== undefined;

        const annualPolicyInfo = policy.annualPolicyInfo;
        const hasUnpaidChange = policy.annualPolicyInfo.hasUnpaidChange;
        const hasUnpaidChargebackInvoice = policy.annualPolicyInfo.hasUnpaidChargebackInvoice;
        const upcomingMtaDate = annualPolicyInfo.maxFutureMtaDate;

        const showFutureMTAHeader: boolean = upcomingMtaDate != null && interaction && interaction.process !== INTERACTION_PROCESS_MTC && !hasUnpaidChange;
        const hasPendingRenewal: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_PENDING_RENEWAL);
        const hasRenewalDeclined: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_UNDERWRITING_FAILURE);
        const hasPolicies = !!policy;
        const hasActivePolicy: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const policyCanceled = policy.status === POLICY_STATUS_MTC;
        const policyNumber = policy.policyNumber;
        const closedRenewalInvite: boolean = window.sessionStorage.getItem(SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED + policyNumber) === "true";
        const today = moment().utc().startOf("day");
        const gracePeriod: boolean = renewalProposal != null && today.isSameOrAfter(moment.utc(renewalProposal.headerInfo.startDate).startOf("day"));
        // This is special case for 2 unpaid instalments
        const showMissedPayment: boolean = !!annualPolicyInfo && annualPolicyInfo.hasDebt;
        let showOverdueInstalmentsBanner: boolean = false;
        showOverdueInstalmentsBanner = AnnualMotorDashboardPage.showOverdueInstalmentBanner(showMissedPayment, isDirectDebitPaymentType, interaction, showOverdueInstalmentsBanner, annualPolicyInfo);
        const ncdImpactedClaim: boolean = policy.interaction.uistate.policyHasNcdImpactedClaims;
        return (
            <>
                <SportsVoucherBanner/>
                <DashcamBanner/>
                {hasActivePolicy && <SportsPassBanner/>}
                {hasActivePolicy && <AllianzAdvantagesBanner/>}
                {policy &&
                    <UpcomingReplaceCarCoverBanner
                        policyNumber={policyNumber}/>}
                {policy && showFutureMTAHeader &&
                    <FutureMTAExplainedHeader
                        policyNumber={policyNumber}
                        policyEndDate={policy.endDate}/>}
                {interaction && <MtaLimitWarningBanner interaction={interaction}/>}
                {(this.state.onlyAnnualMotorPolicyPresent || this.state.hasExpiredPolicies || this.state.hasOldPolicies) &&
                    <CoronaBanner/>}
                {this.state.onlyAnnualMotorPolicyPresent && this.state.policyPropertiesLoaded && !hasPendingRenewal && !this.state.performRenewal && !this.state.automaticRenewalOn &&
                    <NextYearAutoRenewalBanner turnOnNextYearRenewal={this.turnOnNextYearRenewal}
                                               setPerformRenewal={this.setPerformRenewal}/>
                }
                {ncdImpactedClaim && !isDirectDebitPaymentType && !hasActivePolicy && showMissedPayment && <NCDImpactedClaimBanner/>}
                {policy && interaction && ((!showOverdueInstalmentsBanner && +annualPolicyInfo.overdueMonthlyInvoiceAmount > 0) ||
                !showMissedPayment) && (
                    <AnnualProductPaymentMessageBanner
                        showInfoModal={false}
                        interaction={interaction}
                        showMissedPaymentBanner={showMissedPayment}
                        instalmentsInfo={this.getInstalmentsInfoForMonthlyPayment(annualPolicyInfo)}
                        hasRenewalDeclined={hasRenewalDeclined}
                        policyInfo={annualPolicyInfo}
                        amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                        ncdImpactedClaim={ncdImpactedClaim}
                        reuseCard={this.state.reuseCard}
                    />)}
                {policy && interaction && +annualPolicyInfo.overdueAnnualInvoiceAmount > 0 && (
                    <AnnualProductPaymentMessageBanner
                        showInfoModal={false}
                        interaction={interaction}
                        showMissedPaymentBanner={showMissedPayment}
                        instalmentsInfo={instalmentsInfo}
                        hasRenewalDeclined={hasRenewalDeclined}
                        policyInfo={annualPolicyInfo}
                        amount={annualPolicyInfo.overdueAnnualInvoiceAmount}
                        reuseCard={this.state.reuseCard}
                    />)}
                {annualPolicyInfo && showOverdueInstalmentsBanner && (
                    <OverdueInstalmentBanner amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                                             unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                                             policyNumber={interaction.agreementNumber}
                                             product={ProductsEnum.WOLF_MOTOR}
                                             reuseCard={this.state.reuseCard}/>
                )}

                {(policy && hasUnpaidChange) &&
                    <UnpaidChangeBanner unpaidChangeDueDate={annualPolicyInfo.unpaidChangeDueDate}
                                        interaction={interaction}/>}
                {hasUnpaidChargebackInvoice && !isDirectDebitPaymentType &&
                    <ChargebackBanner
                        premiumType={interaction.factors.premiumType}
                        policyNumber={policyNumber}
                    />
                }
                {hasUnpaidChargebackInvoice && !!policy?.annualPolicyInfo.unpaidChargebackInvoiceAmount && isDirectDebitPaymentType &&
                    <OutstandingPaymentBanner
                        amount={policy.annualPolicyInfo.unpaidChargebackInvoiceAmount}
                        policyNumber={policy.policyNumber}
                        product={policy.interaction.product}
                    />
                }
                {policy && showCardExpiryBanner && <CardExpiryBanner
                    party={party!}
                    policyNumber={policy.policyNumber}
                    annualMonthlyOptionCardExpired={this.state.cardExpired!}
                />}
                {hasPendingRenewal && !gracePeriod && (this.state.automaticRenewalOn || this.state.performRenewal) &&
                    <PolicyWillBeRenewedBanner
                        renewalProposal={renewalProposal}
                        product="car"
                        productContent={<>{vehicle.make} {vehicle.model} {vehicle.registrationNumber}</>}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.polarisPolicyData.instalmentAllowedStatus === "A"}
                    />
                }
                {hasRenewalDeclined && hasPolicies && !policyCanceled &&
                    <RenewalDeclinedBanner product="car"
                        endDate={policy.endDate}
                        productWording={<>your {vehicle.make} {vehicle.model} {vehicle.registrationNumber}</>}
                    />
                }
                {!hasActivePolicy && !ncdImpactedClaim && !showMissedPayment && !gracePeriod && <NoActivePolicyBanner/>}
                {hasPendingRenewal && !this.state.automaticRenewalOn && !this.state.performRenewal && !gracePeriod &&
                    <AutoRenewalInviteBanner
                        renewalProposal={this.state.renewalProposal!}
                        setAutomaticRenewal={this.setAutomaticRenewal}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.polarisPolicyData.instalmentAllowedStatus === "A"}
                        renewalEditUrl={RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL}
                        productWording={
                            <>
                                Your car policy for <strong>{vehicle.make} {vehicle.model} ends on {formatDateTime(policy.endDate)}.</strong>{' '}
                                Until then you're still covered.
                            </>
                        }
                    />
                }
                {hasPendingRenewal && this.state.displayWillBeRenewedConfirmation && !gracePeriod &&
                    <PolicyWillBeRenewedConfirmation
                        history={this.props.history}
                        currentPolicy={policy}
                        party={party!}
                        mainCardId={this.state.mainCardId!}
                        renewalProposal={this.state.renewalProposal!}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        showAutoRenewalQuestionModal={directDebitProposal ? this.showDirectDebitProposalModal : this.showAutoRenewalQuestionModal}/>}
                {hasPendingRenewal && !closedRenewalInvite && !this.state.displayWillBeRenewedConfirmation && !this.state.performRenewal && !gracePeriod &&
                    <AutoRenewalInviteAfterLogin
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        isAutoRenewal={this.state.automaticRenewalOn}/>}
                {hasPendingRenewal && !this.state.automaticRenewalOn && gracePeriod &&
                    <GracePeriodBanner
                        renewalProposal={this.state.renewalProposal!}
                        vehicle={vehicle}
                        policy={policy}
                        interaction={interaction}
                    />}
                {hasPendingRenewal && !this.state.automaticRenewalOn && gracePeriod &&
                    <GracePeriodModal
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                    />}
                {hasPendingRenewal && !isDirectDebitPaymentType && !isDirectDebitDetailsSet && (this.state.showDirectDebitProposalModal && !this.state.automaticRenewalOn) &&
                    <DirectDebitProposalModal
                        renewalProposal={this.state.renewalProposal!}
                        onSave={this.showAutoRenewalQuestionModal}
                        ddSelected={this.setAutomaticRenewalMonthlyDD}
                        {...this.props}
                    />}
                {(this.state.showAutoRenewalQuestionModal && !this.state.automaticRenewalOn) &&
                    <AutoRenewalQuestionModal
                        onSave={this.setAutomaticRenewalAndCloseAutoRenewalQuestionModal}
                    />}
                {(this.state.showAutoRenewalQuestionSuccessModal) && <AutomaticRenewalSuccessModal
                    automaticRenewal={this.state.automaticRenewalOn}
                    nextYearRenewal={this.state.performRenewal}
                    product={ProductsEnum.WOLF_MOTOR}
                    closeSuccessModal={this.closeAutoRenewalQuestionSuccessModal}
                />}
            </>
        );
    }

    private static showOverdueInstalmentBanner(showMissedPayment: boolean, isDirectDebitPaymentType: boolean, interaction: any, showOverdueInstalmentsBanner: boolean, annualPolicyInfo: AnnualPolicyInfo) {
        if ((showMissedPayment && isDirectDebitPaymentType && interaction.process !== INTERACTION_PROCESS_MTC_LV) ||
            (!isDirectDebitPaymentType && showMissedPayment && Object.keys(annualPolicyInfo.unpaidInstallmentIdToAmount).length === 2)) {
            showOverdueInstalmentsBanner = showMissedPayment;
        }
        return showOverdueInstalmentsBanner;
    }

    private verifyRenewalProposalStatus(checkStatus: string) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    }

    private handleCloseSuccessPopup = (): void => {
        this.clearSessionStorage();
        this.setTour();
    };

    private clearSessionStorage = (): void => {
        window.sessionStorage.removeItem("cancellationFeeReimbursementIssued");
    };

    private setTour(): void {
        this.tourDriver?.reset();

        this.tourDriver?.defineSteps([
            {
                element: "#carTile",
                popover: {
                    className: "tour",
                    title: "View and make policy changes",
                    description: `Add driver(s), replace car, modify optional extras, modify your car or driver(s) details, all available here.
                                <div>
                                <ul class="nav-dots">
                                    <li class="nav-dot nav-dot-active"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                </ul>
                                </div>`,
                    position: "bottom-right",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour"
                },
                onPrevious: () => {
                    // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
                    // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
                    // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
                    if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                        document.body.style["pointer-events"] = "none";
                        setTimeout(() => {
                            document.body.style["pointer-events"] = "auto";
                        }, 500);
                    }
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#paymentTile",
                popover: {
                    className: "tour",
                    title: "View and amend payment details",
                    description: `Here you can view a history of your payments, set a new payment day
                    or change your card
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour",
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#policyDocumentsTile",
                popover: {
                    className: "tour",
                    title: "Policy documents",
                    description: `This is where you can view and print your policy documents
                   or check the emails we've sent to you
                   <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: "bottom-right",
                    prevBtnText: "Skip tour",
                    nextBtnText: "Next tip"
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#claimsTile",
                popover: {
                    className: "tour",
                    title: "Report a claim online",
                    description: `Here you can make a windscreen, breakdown or all the other type of claims. We have 24 hours helpline
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    prevBtnText: "Restart tour",
                    doneBtnText: "End tour"
                },
                onPrevious: () => {
                    this.tourDriver?.start(1);
                },
            }
        ]);
        this.tourDriver?.start();
    }

    private renderSuccessModal(onClose: any): React.ReactNode {
        const monthly: boolean = this.state.policy!.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            return <SuccessfulPurchaseModal headerText={monthly ? "Deposit payment complete" : "Payment complete"}
                                            modalContent={this.renderSuccessPopup()}
                                            onClose={this.handleCloseSuccessPopup}/>
        } else {
            return <StorageSuccessModal
                title={this.successPopupTitle}
                explanationWording={this.modalContent}
                anythingElseTitle={this.modalAnythingElseChangedTitle}
                explanationAnythingElseWording={this.explanationAnythingElseWording}
                onClose={onClose}
            />
        }
    }

    private renderSuccessPopup(): React.ReactNode {
        const monthly: boolean = this.state.policy?.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY
        if (monthly) {
            return (
                <div className="text-center">
                    <p className="mb-0">Thanks for choosing Allianz!</p>
                    <p className="mb-0">Your Direct Debit instruction will be confirmed to you by email within 3 working days or no later than 10 working days before the first collection.</p>
                    <Link className="hyperlink" to={`/dashboard/annualMotorDocuments/${this.props.match.params.policyNumber}`}>Access your documents</Link>
                    <p className="mt-3">
                        <span className="font-weight-bold">Welcome to your Allianz account</span>,
                        transparent, everything online, customize your cover 24/7
                    </p>
                </div>
            )
        }
        return (
            <div className="text-center">
                <p className="mb-0">Thanks for choosing Allianz!</p>
                <Link className="hyperlink" to={`/dashboard/annualMotorDocuments/${this.props.match.params.policyNumber}`}>Access your documents</Link>
                <p className="mt-3">
                    <span className="font-weight-bold">Welcome to your Allianz account</span>,
                    transparent, everything online, customize your cover 24/7
                </p>
            </div>
        )
    }

    private setSuccessfulPaymentPopup = (): void => {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        const cancellationFeeReimbursementIssued = window.sessionStorage.getItem("cancellationFeeReimbursementIssued") === "true";
        this.modalContent = (
            <div>
                <p className="font-weight-bold mb-4">Thanks {policy.policyHolder.firstName}</p>
                <p className="mb-4">When you’re ready, check your documents in <a className={"link"} href={`/dashboard/annualMotorAccount/${this.props.match.params.policyNumber}`}>your
                    online account</a>. This is also where you’ll manage your policy and make any changes.</p>
                {cancellationFeeReimbursementIssued && (
                    <p className="mb-4">
                        As promised, we'll refund you £40 to your registered payment card to
                        reimburse you for the cancellation fee that you previously paid.
                        The money should be with you shortly (it may take up to 5 days)
                    </p>
                )}
                <p className="mb-4">
                    Remember, we’re just a phone call away if you need to claim, for everything else it’s over to
                    you! If you get stuck, email us and we’ll reply within 24 hours.
                </p>
                <p className="mt-3 font-weight-bold">Welcome to the Allianz family!</p>
                <div className={"d-flex"}>
                    <img src={`/Allianz/img/allianz-olympic-logo.svg`}
                         alt={`Allianz olympics logo icon`} tabIndex={0}/>
                </div>
            </div>
        );
    };

    private setNewPaymentPopup(): void {
        this.successPopupTitle = "Payment was successful";
        this.modalContent = (
            <p>
                We’ve saved your changes and <b>{window.sessionStorage.getItem("paymentAmount")}</b> has been debited
                from your card.<br/>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
        );
    }

    private setNewEditCarPopUp(monthlyPaymentSpreadAmount: number, monthlyPremium: number, previousMonthlyPremium: number | undefined): void {
        this.successPopupTitle = "Payment was successfully added to your payment plan";
        this.modalContent = (
            <div className="font-weight-extra-light">
                <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(previousMonthlyPremium)}
                </span> a month.
                </p>
                <p>The additional cost of <span className="font-weight-semi-bold">
                        {getAmountWithDecimalDigits(monthlyPaymentSpreadAmount)}
                    </span> has increased your remaining monthly payments to <span className="font-weight-semi-bold">
                {getAmountWithDecimalDigits(monthlyPremium)} / month.</span>
                </p>
            </div>
        );
        this.modalAnythingElseChangedTitle = "Has anything else changed?";
        this.explanationAnythingElseWording = "Please check everything’s still accurate and make any changes required so you can be sure all policy details are up to date.";
    }

    private setNewStartDatePopUp(): void {
        const date = window.sessionStorage.getItem("changedStartDate") ? window.sessionStorage.getItem("changedStartDate") : null;
        this.successPopupTitle = "Policy's start date has been changed";
        this.modalContent = (
            <p>
                Your policy will now start on <b>{formatDateDMY(date!)}</b>.
            </p>
        );
    }

    private setEditRenewalSaveSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.mainCardId && this.state.renewalProposal && this.state.policyPropertiesLoaded) {

            let premiumToDisplay: number;
            const premiumType = this.state.renewalProposal!.factors.premiumType;
            const initialPaymentDate: string = moment.utc(this.state.renewalProposal!.renewalDetails.monthlyPayerInitialPaymentDate ?? this.state.renewalProposal!.renewalDetails.annualPayerInitialPaymentDate, moment.ISO_8601).format("DD MMM YYYY");
            if (premiumType === PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = this.state.renewalProposal!.factors.annualPremium;
            } else {
                premiumToDisplay = this.state.renewalProposal!.paymentDetails.instalmentPlan.monthlyPayment;
            }
            const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
            const startDate = moment(this.state.renewalProposal!.headerInfo.startDate!).format("DD MMMM YYYY");

            this.successPopupTitle = "All done! All the changes made to your renewal policy are saved.";
            this.modalContent = (
                <p>
                    <div className='renewal-save-change-success-modal mt-2'>
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                <div className='price-section'>Your new car insurance renewal price
                                    is <span className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span></div>
                                {this.state.automaticRenewalOn &&
                                    <div className='card-section'> and will be taken from your card endings
                                        in <span
                                            className='card-number-bold'>{paymentCard && paymentCard.cardNumberObfuscated.split('******')[1]}</span> on {startDate}.
                                    </div>
                                }
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY && this.state.automaticRenewalOn &&
                            <>
                                <div className='price-section'>Your 1st payment of {' '}<span
                                    className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span>
                                </div>
                                will be taken from card
                                ending in {' '}<span
                                className='card-number-bold'>{paymentCard!.cardNumberObfuscated.split('******')[1]}</span> on {initialPaymentDate}.
                                Please check your payment plan for further dates and amounts.
                            </>
                        }
                        {this.state.automaticRenewalOn &&
                            <div>
                                {' '}Please <Link className="check-your-card-link" to="/dashboard/annualPaymentHistory"
                                                  onClick={() => window.sessionStorage.removeItem("showPopup")}>{' '}check
                                your payment card</Link> is still valid.
                            </div>
                        }


                    </div>
                </p>
            );
        }
    }

    private setEditRenewalSaveSuccessDDPopup(): void {
        this.successPopupTitle = "All done!";
        this.modalContent = (
            <p>
                <div className='renewal-save-change-success-modal mt-2'>
                    <div className='price-section'>All the changes made to your renewal policy are saved.</div>
                </div>
            </p>
        );
    }

    private setSaveClaimImpactPaymentSuccessPopup(): void {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        if (this.state.partyLoaded) {
            const interaction = policy.interaction;

            const {factors, uistate, paymentDetails, policyHolder, agreeToReuseCardDetails} = interaction;

            const mtaSuccessMessageText = window.sessionStorage.getItem("mtaSuccessMessageText");

            const wording = ClaimImpactMtaSuccessModalWordingGenerator.generateModalWording(
                factors, paymentDetails.instalmentPlan!.monthlyPayment, uistate.payFullPrice, mtaSuccessMessageText,
                policyHolder.cardDetails?.at(-1)?.number, agreeToReuseCardDetails);

            window.sessionStorage.removeItem("mtaHeadsUpMessageText");
            window.sessionStorage.removeItem("mtaSuccessMessageText");
            this.successPopupTitle = wording.modalTitle ? wording.modalTitle.toString() : "";
            this.modalContent = (<>{wording.modalBody}</>);
        }
    }

    private setSaveRenewalSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.policyPropertiesLoaded) {
            const policy: Policy = this.state.policy!;
            if (!policy) {
                return;
            }

            let premiumToDisplay: number;
            const premiumType = policy.interaction.factors.premiumType;
            const premiumChangedToMonthly: boolean = policy.interaction.renewalDetails?.lyPremiumType === PREMIUM_TYPE_ANNUAL && policy.interaction.factors.premiumType === PREMIUM_TYPE_MONTHLY;
            if (premiumType === PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = policy.interaction.factors.annualPremium;
            } else {
                premiumToDisplay = policy.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            }
            const firstInstallment: number = policy.interaction.paymentDetails.instalmentPlan.instalments[0].principal + policy.interaction.paymentDetails.instalmentPlan.instalments[0].interest;
            const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
            const vehicle: any = policy.interaction.vehicles[0];
            const paymentDate = premiumType === PREMIUM_TYPE_ANNUAL ? moment(policy.interaction.renewalDetails.annualPayerProposedSecondPaymentDate).format("DD MMMM") : moment(policy.interaction.renewalDetails.monthlyPayerInitialPaymentDate).format("DD MMMM");

            this.successPopupTitle = premiumType === PREMIUM_TYPE_MONTHLY && !premiumChangedToMonthly ? `You have set up your ${vehicle.make}, ${vehicle.model} (${vehicle.registrationNumber}) car insurance policy to renew` : "Payment was successful";
            this.modalContent = (
                <p>
                    <div className='renewal-save-change-success-modal mt-2'>
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                <div className='price-section'><span
                                    className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span> was taken from
                                    your card ending in <span
                                        className='card-number-bold'>{paymentCard && paymentCard.cardNumberObfuscated.split('******')[1]}</span>
                                    {" "}for renewing your {vehicle.make}, {vehicle.model} ({vehicle.registrationNumber})
                                    car policy.
                                    <p>
                                        Please allow a couple of minutes for the payment to be updated in your account.
                                    </p>
                                </div>
                                <div className='card-section'>
                                    Thanks choosing Allianz for another year!
                                </div>
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY && !premiumChangedToMonthly &&
                            <>
                                <div className='price-section'>
                                    Your 1st payment of {' '}
                                    <span className='price-bold'>
                                        {getAmountToDisplay(premiumToDisplay)}
                                    </span>
                                </div>
                                will be taken from card ending in {' '}
                                <span className='card-number-bold'>
                                    {paymentCard!.cardNumberObfuscated.split('******')[1]}
                                </span> on {paymentDate}.
                                Please check your payment plan for further dates and amounts.
                                {' '}Please
                                <Link className="check-your-card-link" to="/dashboard/annualPaymentHistory"
                                      onClick={() => window.sessionStorage.removeItem("showPopup")}>{' '}
                                    check your payment card
                                </Link> is still valid.
                            </>}
                        {premiumType === PREMIUM_TYPE_MONTHLY && premiumChangedToMonthly &&
                            <>
                                <div className='price-section'>
                                    <span className='price-bold'>
                                        {getAmountToDisplay(firstInstallment)}
                                    </span>
                                </div>
                                has been taken out from card ending in
                                <span className='card-number-bold'>
                                    {paymentCard!.cardNumberObfuscated.split('******')[1]}
                                </span> as first installment for renewing
                                your {vehicle.make}, {vehicle.model} ({vehicle.registrationNumber}) car policy.
                                <div className='card-section'>
                                    Thanks choosing Allianz for another year!
                                </div>
                            </>}
                    </div>
                </p>
            );
        }
    }

    private setAutomaticRenewal(value: boolean): void {
        this.setState({
            displayOverlay: true
        });

        this.customerPortalService.storePolicyAutomaticRenewalFlag(this.props.match.params.policyNumber, value)
            .subscribe(() => {
                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.match.params.policyNumber},automaticRenewal`);

                    this.setState({
                        automaticRenewalOn: value,
                        displayOverlay: false
                    })
                }
            )
    }

    private setPerformRenewal(value: boolean): void {
        this.setState({
            displayOverlay: true
        });

        this.customerPortalService.storePolicyPerformRenewalFlag(this.props.match.params.policyNumber, value)
            .subscribe(() => {
                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.match.params.policyNumber},performRenewal`);

                    this.setState({
                        performRenewal: value,
                        displayOverlay: false
                    })
                }
            )
    };


    private showHideWillBeRenewedConfirmation = (display: boolean): void => {
        this.setState({
            displayWillBeRenewedConfirmation: display
        })
    }

    private showAutoRenewalQuestionModal = (): void => {
        this.setState({
            showAutoRenewalQuestionModal: true
        });
    }

    private showDirectDebitProposalModal = (): void => {
        this.setState({
            showDirectDebitProposalModal: true
        });
    }

    private setAutomaticRenewalMonthlyDD = (automaticRenewal: boolean): void => {
        // true when user accepted next year renewal in modal
        // auto renewal case must also set next year flag to true - FAL-38597
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showDirectDebitProposalModal: false,
            showAutoRenewalQuestionSuccessModal: false,
            performRenewal: true,
            automaticRenewalOn: automaticRenewal
        })
    }

    private setAutomaticRenewalAndCloseAutoRenewalQuestionModal = (automaticRenewal: boolean): void => {
        // true when user accepted next year renewal in modal
        // auto renewal case must also set next year flag to true - FAL-38597
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showDirectDebitProposalModal: false,
            showAutoRenewalQuestionSuccessModal: true,
            performRenewal: true,
            automaticRenewalOn: automaticRenewal
        })
    }

    private closeAutoRenewalQuestionSuccessModal = (): void => {
        this.setState({
            showAutoRenewalQuestionSuccessModal: false
        })
    }

    private displayReviewDialog() {
        const createRevPromises: Array<Promise<any>> = [];
        createRevPromises.push(this.customerPortalService.createReviewRequest(this.props.match.params.policyNumber).toPromise());

        Promise.all(createRevPromises).then(() => {
            // display feedback dialog after delay
            window[FEEDBACK_DIALOG_DISPLAY_COUNTER] = setTimeout(() => {
                dispatchEvent(new Event(FEEDBACK_DIALOG_DISPLAY_EVENT));
            }, 30_000); // display after 30 seconds
        });
    }

    private turnOnNextYearRenewal(): void {
        // it was agreed that opt-in turns automatic renewal and both flags must be true - FAL-38597
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(true);
        this.setState({
            showRenewalSwitchConfirmation: true
        })
    }

    private setPopups(): any {
        let onClose;
        this.explanationAnythingElseWording = "";
        this.modalAnythingElseChangedTitle = "";
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            onClose = this.handleCloseSuccessPopup;
            this.setSuccessfulPaymentPopup();
        } else if (this.referrerJourney === NEW_PAYMENT) {
            window.sessionStorage.removeItem("paymentSettings");
            this.setNewPaymentPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_MTA_EDIT_CAR_DETAILS) {
            const factors = this.state.policy?.interaction.factors;
            if (factors) {
                const monthlyPaymentAmount: number = factors.monthlyPaymentSpreadWithInterestAmount || factors.monthlyPaymentSpreadAmount;
                this.setNewEditCarPopUp(monthlyPaymentAmount, factors.monthlyPremium, this.state.previousMonthlyPremium);
            }
        } else if (this.referrerJourney === INTERACTION_PROCESS_PENDING_RENEWAL) {
            this.setEditRenewalSaveSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_PENDING_RENEWAL_DD) {
            this.setEditRenewalSaveSuccessDDPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_RENEWAL) {
            if (!this.state.automaticRenewalOn) {
                onClose = this.showAutoRenewalQuestionModal;
            }
            this.setSaveRenewalSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE) {
            this.setNewStartDatePopUp();
        } else if (this.referrerJourney === INTERACTION_PROCESS_CLAIM_IMPACT) {
            this.setSaveClaimImpactPaymentSuccessPopup();
        } else {
            window.sessionStorage.removeItem("showPopup");
            window.sessionStorage.removeItem("referrerJourney");
        }
        return onClose;
    }

    private getInstalmentsInfoForMonthlyPayment(annualPolicyInfo: any) {
        if (+annualPolicyInfo.overdueMonthlyInvoiceAmount > 0 &&
        +annualPolicyInfo.overdueAnnualInvoiceAmount > 0) {
            return this.state.allInstalmentsInfo;
        }
        return this.state.instalmentsInfo;
    }

    private filterByProduct(policies: Policy[], product: ProductsEnum): Policy[] {
        return policies.filter(p => p.products.includes(product));
    }

    private hasOldHomePolicies(policies: Policy[]): boolean {
        return this.filterByProduct(policies, ProductsEnum.HOME).length > 0
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/dashboardPage/AnnualMotorDashboardPage.tsx